import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { RangeStyled } from '../RangeStyled';
import { rem } from 'polished';

export const RangeStyledOV = styled(RangeStyled)`
    margin-top: 0;

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(20)};
    }

    .rc-slider {
        position: relative;
        height: 1.5rem;
        padding: 5px 0;
    }

    .rc-slider-rail {
        background-color: ${props => props.theme.colors.grey4};
        height: ${rem('3px')};
        position: absolute;
        width: 100%;
        border-radius: 0.25rem;
    }
    .rc-slider-track {
        background-color: ${props => props.theme.colors.black};
        height: ${rem('3px')};
        position: absolute;
        left: 0;
        border-radius: 0.25rem;
    }
    .rc-slider-handle {
        background-color: ${props => props.theme.colors.grey20};
        border: solid 1px ${props => props.theme.colors.grey2};
        width: ${rem(20)};
        height: ${rem(20)};
        cursor: grab;
        position: absolute;
        margin-top: ${rem(-8)};
        border-radius: 50%;
    }

    .rc-slider-handle-dragging {
        box-shadow: 0 0 2px 2px ${props => props.theme.colors.primary};
        background: ${props => props.theme.colors.primary};
    }
    .rc-slider-handle:hover {
        box-shadow: 0 0 1px 1px ${props => props.theme.colors.primary};
    }
    .range-display {
        color: ${props => props.theme.colors.black};
        font-weight: ${({ theme }) => theme.fontWeights.textMedium};
        font-family: ${({ theme }) => theme.fonts.fontBase};
    }
`;
